<template>
  <div>
  <HeroSection/>
  <IntroSection imageUrl="img/intro-img.jpg"
                titlePrefix="מאפרת מקצועית באשדוד"
                title="יעל תמם | מאפרת מקצועית באשדוד - איפור כלות וערב"
                quote='"אהבה ליופי, כמו אהבה לטוב, לא צריכה הסבר." - אפלטון'
                body="מחפשת מאפרת מקצועית באשדוד והסביבה? יעל תמם מתמחה באיפור כלות ומלוות, איפור ערב, תסרוקות והעברת סדנאות לאיפור אישי. תקבלי איפור מותאם אישית, ביחס חם, מקצועיות ודיוק הנובעים מאהבת המקצוע - כדי שתרגישי יפה, זוהרת ובטוחה בעצמך."/>
  <PortfolioSection/>
  </div>
</template>

<script>
import HeroSection from './HeroSection'
import IntroSection from './IntroSection'
import PortfolioSection from './PortfolioSection'

export default {
  name: 'app',
  components: {
    HeroSection,
    IntroSection,
    PortfolioSection
  }
}

</script>

<style>
#app {
  font-family: 'Varela Round', sans-serif;
	-webkit-font-smoothing: antialiased;
	font-smoothing: antialiased;
	direction: rtl;
}
</style>
